import { useMemo } from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { useConfig } from '@cp/shared/config';
import { DefenceIcon } from '@cp/ds/src/icons';
import { AchivementsProps } from './model';

export const Achievement = (props: AchivementsProps) => {
  const theme = useTheme();
  const config = useConfig();

  const title = useMemo(() => {
    switch (props.type) {
      case 'verified':
        return 'проверен';
      case 'online':
        return 'онлайн';
      case 'school':
        return `школа ${config.get('APP_NAME') ?? 'нянь'}`;
      default:
        return '';
    }
  }, [props.type, config]);

  const icon = useMemo(() => {
    switch (props.type) {
      case 'verified':
        return <DefenceIcon sx={{ mr: 0.25, fontSize: '1rem' }} />;
      case 'online':
        return <Box sx={{ height: '8px', marginRight: '4px', width: '8px', backgroundColor: '#6AD059', borderRadius: 10 }} />;
      case 'school':
        return null;
      default:
        return '';
    }
  }, [props.type]);

  if (!title) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: props.type === 'online' ? theme.palette.green : theme.palette.gray,
        borderRadius: '6px',
        px: 1,
      }}
    >
      {icon}
      <Typography sx={{ py: 0.25 }} variant="small text bold">
        {title}
      </Typography>
    </Box>
  );
};
